import styles from "./ReviewsCarousel.module.scss";
import Review from "../ListingReview";

export default function ReviewsCarousel({ reviewList }) {
  return (
    <div className={styles.ReviewsSlider}>
      {reviewList.slice(0, 5).map((review, index) => {
        return (
          <div key={index} className={styles.ReviewsByCityItem}>
            <div className={styles.ReviewCard}>
              <Review {...review} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
